import { Pipe, PipeTransform } from '@angular/core';
import { convertIsoToJalaali } from '../utils/convert-iso-to-jalaali';

@Pipe({
  name: 'persianDate',
  standalone: true,
})
export class PersianDatePipe implements PipeTransform {
  constructor() {}

  transform(
    date: Date | string | null,
    customFormat?: string,
    includeTime?: boolean
  ): boolean {
    // @ts-ignore
    return !!date ? convertIsoToJalaali(date, customFormat, includeTime) : '';
  }
}
